<template>
  <TooltipWrapper>
    <template #trigger>
      <ChipBadge :color="colorByState" rounded>
        {{ t(`Reviews.product.view.table.statusLabel.${state}`, t('Reviews.product.view.table.statusLabel.unknown')) }}
      </ChipBadge>
    </template>
    <template v-if="tooltipContentByState" #content>
      <div class="max-w-xs" v-html="tooltipContentByState" />
    </template>
  </TooltipWrapper>
</template>
<script setup lang="ts">
import { ChipBadge, TooltipWrapper } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { SurveyResponse } from '@/components/ReviewsManagement/Reviews/types.ts'
import { SurveyResponseState, useSurveyResponseState } from '@/composables/useSurveyResponseState.ts'
import { SurveyResponseRejectedReasons } from '@/gql/reviews'

const props = defineProps<{
  surveyResponse: SurveyResponse
}>()

const { t } = useI18n()

const state = useSurveyResponseState(props.surveyResponse)

const colorByState = computed(() => {
  switch (state.value) {
    case SurveyResponseState.Published:
      return 'mint'
    case SurveyResponseState.Drafted:
    case SurveyResponseState.ReDrafted:
      return 'purple'
    case SurveyResponseState.Rejected:
      return 'error'
    case SurveyResponseState.Proposed:
      return 'yellow'
    case SurveyResponseState.Stale:
      return 'default'
    default:
      return 'default'
  }
})

const tooltipContentByState = computed(() => {
  switch (state.value) {
    case SurveyResponseState.Rejected:
      return t('Reviews.product.review.rejected.reason.tooltip', {
        reason: t(`Reviews.product.review.rejected.reason.${props.surveyResponse.rejectedReason || SurveyResponseRejectedReasons.Invalid}`),
      })
    case SurveyResponseState.Proposed:
      return t('Reviews.product.review.proposed.tooltip')
    case SurveyResponseState.Stale:
      return t('Reviews.product.review.stale.tooltip')
    case SurveyResponseState.ReDrafted:
      return t('Reviews.product.review.reDrafted.tooltip')
    default:
      return undefined
  }
})
</script>
